/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import Axios from "axios";
import bg from "../img/bg.png";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import No_image from "../img/No_Image.jpg"
import monitor from "../img/monitor.png"
import { checkGroupsUser, getlocalStorage, getReasonText } from '../function/functionALL';
import CheckNoContent from '../components/CheckNoContent'
import Swal from 'sweetalert2';
import ModalReport from '../components/ModalReport'

require("moment/locale/th");

const ModalScore = ({ IdUser, NoneImg }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [imageUrl, setimageUrl] = useState([]);
    const navigate = useNavigate()
    const [data, setdata] = useState([]);
    const [test_results_list, settest_results_list] = useState([]);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole




    const handleShow = () => {
        Axios.get(process.env.REACT_APP_API_USERS + `${IdUser}/`, {
            headers: {
                Authorization: "Token " + Token,
            },
        })
            .then((res) => {
                setdata(res.data);
                settest_results_list(res.data.test_results_list);
                setShow(true);
                // const imageUrlHTTPS = res.data.image.replace(/^http:/, 'https:');
                // setimageUrl(imageUrlHTTPS);
                if (res.data.image) {
                    const imageUrlHTTPS = res.data.image.replace(/^http:/, "https:");
                    setimageUrl(imageUrlHTTPS);
                } else {
                    setimageUrl(null);
                }

            })
            .catch((err) => {
                if (err.response.status === 401) {
                    localStorage.removeItem("Token_");
                    localStorage.removeItem("Token");
                    navigate('/notfound404',

                    )
                }
                console.error(err);
                Swal.fire({
                    icon: "error",

                })
            });
    };

    // const imageSource = data.image ? data.image : No_image;
    return (
        <>

            {!role ?
                <div onClick={handleShow} >
                    <button type="button" className="btn btn-primary px-4" style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} >
                        ดูผลคะแนน
                    </button>
                </div>
                :
                <div className={NoneImg && role ? "row col-sm-12  col-lg-4 m-0 pt-2" : null} onClick={handleShow}>
                    <button type="button" className="btn btn-primary px-4"
                        style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                    >
                        <div className="row col-12 p-0 m-0 justify-content-center">
                            {NoneImg &&
                                <div className="col-3 col-sm-12 col-lg-12 text-center ">
                                    <img
                                        src={monitor}
                                        style={{
                                            maxHeight: "50px",
                                            objectFit: "cover",
                                        }}
                                    />
                                </div>
                            }
                            <div className={!role ? "col-8  col-sm-12 mt-lg-3 d-flex align-items-center justify-content-center text-center " : null}>
                                {!role ? "ผลการทดสอบรายบุคคล" : "ดูผลคะแนน"}
                            </div>
                        </div>
                    </button>
                </div>

            }
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Header>
                    <p className="m-0 fw-bold" style={{ fontSize: "18px" }}>ผลคะแนนการทดสอบ</p>
                    <button
                        type="button"
                        className="btn btn-primary custom-close-button"
                        style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                        onClick={handleClose}
                    >
                        ปิด
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className=" rounded ">
                        <div className="p-sm-3">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2">
                                        <div className="fw-bold text-center" style={{ fontSize: "25px" }}>ประวัติการทดสอบ</div>
                                    </div>
                                    {/* <!-- No Labels Form --> */}
                                    <div >
                                        <div className="px-3 flex-lg-row card shadow-lg " style={{
                                            backgroundImage: `url(${bg})`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "100% 100%",
                                            color: "#000000",
                                            width: "100%",
                                            borderRadius: "10px"

                                        }} >
                                            <div className="p-3 col-12 col-lg-4 text-center">
                                                {imageUrl !== null ? (<img src={imageUrl} alt="Profile" className="rounded" style={{ objectFit: 'cover', width: '70%', height: 'auto' }} />) : (
                                                    <img src={No_image} alt="Profile" className="rounded" style={{ objectFit: 'cover', width: '70%', height: 'auto' }} />
                                                )}
                                            </div>
                                            <div className="p-sm-3 p-1 col-12 col-lg-8 mb-2">
                                                <div className="tab-pane fade show active profile-overview" id="profile-overview">
                                                    <div className="col-12 col-sm-12">
                                                        <h5 className="fw-bold text-center" style={{ color: "#000000" }}>ข้อมูลปัจจุบัน</h5>
                                                    </div>
                                                    <div className="p-3 col-12 col-sm-12" style={{ fontSize: "14px" }}>
                                                        <div className="col-12 col-sm-12  ms-2 d-flex">
                                                            <div className="col-4 col-sm-3 fw-bold">ชื่อ</div>
                                                            <div className="col-8 col-sm-9 label">{data.full_name}</div>
                                                        </div>
                                                        <div className="col-12 col-sm-12 ms-2 d-flex">
                                                            <div className="col-4 col-sm-3 fw-bold">ตำแหน่ง</div>
                                                            <div className="col-8 col-sm-9 label">{data.position}</div>
                                                        </div>
                                                        <div className="col-12 col-sm-12 ms-2 d-flex">
                                                            <div className="col-4 col-sm-3 fw-bold">สังกัด</div>
                                                            <div className="col-8 col-sm-9 label">{data.unit}</div>
                                                        </div>
                                                        <div className="col-12 col-sm-12 ms-2 d-flex">
                                                            <div className="col-4 col-sm-3 fw-bold">ปฏิบัติหน้าที่</div>
                                                            <div className="col-8 col-sm-9 label">{data.work_unit}</div>
                                                        </div>
                                                        <div className="col-12 col-sm-12 ms-2 d-flex">
                                                            <div className="col-4 col-sm-3 fw-bold">อายุ</div>
                                                            <div className="col-8 col-sm-9 label">{data.age} ปี</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- Horizontal Form --> */}
                                        {test_results_list.length === 0 ? (
                                            <CheckNoContent />

                                        ) : <div className="table table-hover overflow-auto" style={{ height: "800px" }}>
                                            <table className="table_content table table-hover" style={{ backgroundColor: "white" }}>
                                                <thead>
                                                    <tr >
                                                        {/* <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", height: "70px", width: "10%" }}>
                                                         <p>ภาค</p>   
                                                        </th> */}
                                                        <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "20%" }}>
                                                            วงรอบ
                                                        </th>
                                                        <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "14%" }}>
                                                            ดันพื้น (ครั้ง)
                                                        </th>
                                                        <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "14%" }}>
                                                            ลุกนั่ง (ครั้ง)
                                                        </th>
                                                        <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "14%" }}>
                                                            วิ่ง (นาที)
                                                        </th>
                                                        <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "14%" }}>
                                                            เดิน (นาที)
                                                        </th>
                                                        {/* <th scope="col" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "#9DA4F1", color: "black", width: "14%" }}><p>ผล</p></th> */}

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {test_results_list.map((Data, i) => (
                                                        <tr className="raw" key={i}>
                                                            {/* <td className="pt-3" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "rgb(208,217,255,0.4)" }}>
                                                                
                                                            </td> */}
                                                            <td className="pt-3" style={{ fontSize: "12px", textAlign: "center", backgroundColor: "rgb(208,217,255,0.4)" }}>
                                                                <span>
                                                                    {Data.is_air_worker === false ? "พื้น" : "อากาศ"} / {" "}
                                                                    {Data.test_round_text} ({Data.test_round_unit})
                                                                    {" "}<ModalReport IdRound={Data.id} imageUrl={imageUrl} />
                                                                </span>

                                                            </td>
                                                            {Data.absent_comment !== "" || Data.absent_reason !== 0 ? (
                                                                <td colSpan="5" className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center", verticalAlign: "middle", backgroundColor: "rgb(211,211,211,0.7)" }}>
                                                                    {getReasonText(Data.absent_reason)} {Data.absent_comment ? `(${Data.absent_comment})` : ""}
                                                                </td>
                                                            ) : (
                                                                <>
                                                                    <td className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center", verticalAlign: "middle" }}>
                                                                        {Data.pushup.quantity === -1 ? " " : Data.pushup.quantity}
                                                                    </td>
                                                                    <td className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center", verticalAlign: "middle" }}>
                                                                        {Data.situp.quantity === -1 ? " " : Data.situp.quantity}
                                                                    </td>
                                                                    <td className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center", verticalAlign: "middle" }}>
                                                                        {Data.run.quantity === -1 || Data.run.quantity === "-1:59" ? " " : Data.run.quantity}
                                                                    </td>
                                                                    <td className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center", verticalAlign: "middle" }}>
                                                                        {Data.walk.quantity === -1 || Data.walk.quantity === "-1:59" ? " " : Data.walk.quantity}
                                                                    </td>
                                                                    {/* <td className="pt-3 text-center" style={{ fontSize: "12px", textAlign: "center" }}>

                                                                      
                                                                    </td> */}
                                                                </>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )

}

export default ModalScore